// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1EWUz","sendOtp":"AuthorizeToLogin_sendOtp__222F_"};